import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  logOutButton: {
    position: 'fixed',
    top: '12px',
    right: '40px',
    zIndex: '20',
    [breakpointsFunc.breakpoints.down(1079.5)]: {
      top: '37px'
    }
  }
});
export default useStyles;